import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Users, Home, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Services() {
  const services = [{
    id: 1,
    icon: Clock,
    area: 'Område 1',
    title: 'Du leder bolaget – men hinner inte leda utvecklingen',
    problem: 'Verksamheten rullar. Kunderna är nöjda. Men utvecklingen går långsammare än du vill.',
    consequence: 'Initiativ startar – men tappar fart. Du blir flaskhalsen. Strategin lever i PowerPoint.',
    solution: '1 dag/vecka som strategisk partner. Vi skapar riktning, prioritering och rörelse.',
    color: 'terracotta',
    href: '/omrade-1'
  }, {
    id: 2,
    icon: Users,
    area: 'Område 2',
    title: 'Från familj till by – när ett team blir tre',
    problem: 'Alla jobbar hårt. Ändå känns det som att hjulen snurrar i lös sand.',
    consequence: 'Möten utan beslut. Ansvar utan ägare. Chefen blir navet i nästan allt.',
    solution: 'Vi designar strukturen som gör riktningen genomförbar – och som inte landar allt hos VD.',
    color: 'sage',
    href: '/omrade-2'
  }, {
    id: 3,
    icon: Home,
    area: 'Område 3',
    title: 'Hybridarbete – infört men inte designat',
    problem: 'Man har bestämt var man ska arbeta. Inte hur arbetet faktiskt ska fungera.',
    consequence: 'Långa möten utan output. Engagemang som sjunker. Hybridmodellen ifrågasätts.',
    solution: 'Vi designar arbetssättet – inte bara policyn. Hybrid ska höja prestation, inte sänka den.',
    color: 'terracotta',
    href: '/omrade-3'
  }];
  return <section id="services" className="py-24 md:py-32 px-6 bg-background" data-id="element-172">
      <div className="max-w-7xl mx-auto" data-id="element-173">
        <div className="text-center mb-16 max-w-2xl mx-auto" data-id="element-174">
          <motion.span className="text-sage font-medium tracking-widest text-sm uppercase mb-4 block" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} data-id="element-175">
            Vad vi gör
          </motion.span>
          <motion.h2 className="text-3xl md:text-4xl font-normal text-ink mb-4" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} data-id="element-176">
            Tre områden. Samma grundproblem.
          </motion.h2>
          <motion.p className="text-muted text-lg" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} data-id="element-177">
            För lite tid, för mycket att göra, och ett team som förtjänar
            bättre.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-178">
          {services.map((service, index) => <motion.div key={service.id} className="bg-card rounded-2xl p-8 shadow-sm flex flex-col h-full" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-179">
              <div className={`w-12 h-12 rounded-full flex items-center justify-center mb-6 ${service.color === 'terracotta' ? 'bg-terracotta/10 text-terracotta' : 'bg-sage/10 text-sage'}`} data-id="element-180">
                <service.icon className="w-6 h-6" strokeWidth={1.5} data-id="element-181" />
              </div>

              <span className={`text-xs font-medium tracking-widest uppercase mb-2 ${service.color === 'terracotta' ? 'text-terracotta' : 'text-sage'}`} data-id="element-182">
                {service.area}
              </span>

              <h3 className="text-lg font-medium text-ink mb-4 leading-snug" data-id="element-183">
                {service.title}
              </h3>

              <div className="space-y-4 flex-grow" data-id="element-184">
                <p className="text-sm text-muted italic" data-id="element-185">"{service.problem}"</p>
                <p className="text-sm text-muted" data-id="element-186">{service.consequence}</p>
                <div className="pt-4 border-t border-border mt-4" data-id="element-187">
                  <p className="text-sm text-ink font-medium" data-id="element-188">
                    {service.solution}
                  </p>
                </div>
              </div>

              <div className="mt-8 flex flex-col gap-3" data-id="element-189">
                {service.href ? <Link to={service.href} className={`flex items-center text-sm font-medium group ${service.color === 'terracotta' ? 'text-terracotta' : 'text-sage'}`} data-id="element-190">
                    Utforska området
                    <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-191" />
                  </Link> : <button className={`flex items-center text-sm font-medium group ${service.color === 'terracotta' ? 'text-terracotta' : 'text-sage'}`} onClick={() => window.location.href = 'mailto:peter@humble-consulting.se'} data-id="element-192">
                    Boka ett samtal
                    <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-193" />
                  </button>}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}